//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailFlow from "@/pccomponents/detailFlow";
import FileUpload from "@/pccomponents/FileUpload";
import ModuleTitle from "@/pccomponents/ModuleTitle";
import staffentryBaseinfo from "@/pcpage/hr/personnel/staffentry/staffentrybaseinfo";
import staffentryResumeinfo from "@/pcpage/hr/personnel/staffentry/staffentryresumeinfo";
import staffentryFamilyinfo from "@/pcpage/hr/personnel/staffentry/staffentryfamilyinfo";
import staffentryEduinfo from "@/pcpage/hr/personnel/staffentry/staffentryeduinfo";
import staffentryTraininginfo from "@/pcpage/hr/personnel/staffentry/stafftraininginfo";
import staffentryOfficialexaminfo from "@/pcpage/hr/personnel/staffentry/staffentryofficialexaminfo";
import staffentryCommunityinfo from "@/pcpage/hr/personnel/staffentry/staffentrycommunityinfo";
import staffentryTechnical from "@/pcpage/hr/personnel/staffentry/staffentrytechnical";
import staffentryMapfile from "@/pcpage/hr/personnel/staffentry/staffentrymapfile";
import commonLoad from "@/pcpage/hr/common/commonload"

import formValidate from "@/js/formValidate";

export default {
  name: 'onboardingload',
  extends: commonLoad,
  components: {
    DetailFlow,
    FileUpload,
    ModuleTitle,
    staffentryBaseinfo,
    staffentryResumeinfo,
    staffentryFamilyinfo,
    staffentryEduinfo,
    staffentryTraininginfo,
    staffentryOfficialexaminfo,
    staffentryCommunityinfo,
    staffentryTechnical,
    staffentryMapfile,

  },
  data() {
    return {
      formName: 'staffmainForm', //表单名称
      passtoken:true,
      record: {
        rowList: [], //行表信息
        delrowids: [], //传给后端的删除行id，从逗号分隔的字符串，改为数组，
        rowmodel: {}, //单据行项模版
        fileList: [],
        fileids: [],
        mapfileLists: [],
        mapfileids: [],
      }, //保存的数据
      staffEntryConfig: {
        //添加照片
        fielphto: true,
        //添加履历记录
        addresume: false,
        //添加教育经历
        addedu: false,
        //添加家庭信息
        addfam: false,
        //添加受训经历
        addtraining: false,
        //添加公务考试信息
        addoff: false,
        //添加社团信息
        addcom: false,
        btype: "ONBOARDING",
        //图片
        tagname: "bentryapplyfile",
        //居住地图附件
        tagnamemap: "bentryapplymapfile",

        tabname: "bentryapply",

        doUpload: "onboarding/upload",
        getUpload: "onboarding/getfile",
        delUpload: "onboarding/delete",

        dropUrl: "onboarding/getSelectOption",
        delImgUrl: "onboarding/delefilebyId",
      },

      params: {}, //业务单据保存回来后的参数
    }

  },
  methods: {
    /**
     * 页面初始化
     */
    async init() {
      this.initParam();
    },
    /**
     * 初始化参数
     */
    initParam() {
      this.currpathid = "90100";
      this.saveAction = "onboarding/save";
      this.deleteAction = "onboarding/delete";
      this.loadAddAction = "onboarding/loadAdd";
      this.loadAction = "onboarding/load";
      this.currRouterPath = "/onboarding/onboardingload";
      this.validFormInfo.mainFormName = "staffmainForm";
      this.validFormInfo.childComponentName.push("baseinfoForm");
      this.validFormInfo.childComponentName.push("resumeinfoForm");
      this.validFormInfo.childComponentName.push("eduinfoForm");
      this.validFormInfo.childComponentName.push("familyinfoForm");
      this.validFormInfo.childComponentName.push("familyinfoForm");
      this.validFormInfo.childComponentName.push("traininginfoForm");
      this.validFormInfo.childComponentName.push("officialexaminfoForm");
      this.validFormInfo.childComponentName.push("communityinfoForm");
      this.validFormInfo.childComponentName.push("technicalinfoForm");
      this.validFormInfo.childComponentName.push("mapfileForm");
      this.fileidname = ['fileids'];
    },
    /**
     * 初始化特殊编辑项
     */
    initConfig() {

      let editItems = this.process.editItems;
      console.log("editItems:" + editItems);
      if (editItems != null && editItems.indexOf(";FIELPHTO;") > -1 && this.record.id) {
        //配置项开启时添加照片按钮
        this.staffEntryConfig.fielphto = true;
      }
      if (editItems != null && editItems.indexOf(";ADDRESUME;") > -1) {
        //配置项开启时展示添加履历记录
        this.staffEntryConfig.addresume = true;
        if ((undefined == this.record.staffresumerow || this.record.staffresumerow.length <= 0) && !this.record.id) {
          this.addrow(this.record.staffresumerow);
        }
      }
      if (editItems != null && editItems.indexOf(";ADDEDU;") > -1) {
        //配置项开启时展示添加教育经历
        this.staffEntryConfig.addedu = true;
        if ((undefined == this.record.staffedurow || this.record.staffedurow.length <= 0) && !this.record.id) {
          this.addrow(this.record.staffedurow);
        }
      }
      if (editItems != null && editItems.indexOf(";ADDFAM;") > -1) {
        //配置项开启时展示添加家庭信息
        this.staffEntryConfig.addfam = true;
        if ((undefined == this.record.familyrow || this.record.familyrow.length <= 0) && !this.record.id) {
          this.addrow(this.record.familyrow);
        }
      }
      if (editItems != null && editItems.indexOf(";ADDTRAINING;") > -1) {
        //配置项开启时展示添加受训经历
        this.staffEntryConfig.addtraining = true;
        if ((undefined == this.record.trainingrow || this.record.trainingrow.length <= 0) && !this.record.id) {
          this.addrow(this.record.trainingrow);
        }
      }
      if (editItems != null && editItems.indexOf(";ADDOFF;") > -1) {
        //配置项开启时展示添加公务考试信息
        this.staffEntryConfig.addoff = true;
        if ((undefined == this.record.officialexamrow || this.record.officialexamrow.length <= 0) && !this.record.id) {
          this.addrow(this.record.officialexamrow);
        }
      }
      if (editItems != null && editItems.indexOf(";ADDCOM;") > -1) {
        //配置项开启时展示添加社团信息
        this.staffEntryConfig.addcom = true;
        if ((undefined == this.record.communityrow || this.record.communityrow.length <= 0) && !this.record.id) {
          this.addrow(this.record.communityrow);
        }
      }
    },
    /**
     *回写附件ID
     */
    setFileid(obj) {
      this.record["fielphto"] = obj;
    },
    /**
     * 流程加载完毕后
     */
    doLoadRecordAfter(oQuery, data) {
      //根据编辑项条件判断
      this.initConfig();
      if(this.isNotNullOrEmpty(this.record.fielphto)){
        this.$refs.baseinfoForm.getImageNotLogin(this.record.fielphto);
      }

      //若已保存，则置空可编辑域
      if(!this.ifsave){
        this.process="";
        this.staffEntryConfig={
          //添加照片
          fielphto: false,
          //添加履历记录
          addresume: false,
          //添加教育经历
          addedu: false,
          //添加家庭信息
          addfam: false,
          //添加受训经历
          addtraining: false,
          //添加公务考试信息
          addoff: false,
          //添加社团信息
          addcom: false,
          btype: "ONBOARDING",
          //图片
          tagname: "bentryapplyfile",
          //居住地图附件
          tagnamemap: "bentryapplymapfile",

          tabname: "bentryapply",

          doUpload: "onboarding/upload",
          getUpload: "onboarding/getfile",
          delUpload: "onboarding/delete",

          dropUrl: "onboarding/getSelectOption",
          delImgUrl: "onboarding/delefilebyId",
        };
        //重新赋值附件的ID
        let t_record = oQuery.record;
        if(this.fileidname && this.fileidname.length >0){
          for(var i = 0  ; i < this.fileidname.length; i++){
              let attr  = this.fileidname[i];
              if(t_record && t_record[attr] && t_record[attr] != ''){
                this.$set(this.record,attr,t_record[attr]);
              }
          }
        }
      }

      //设置文件id
      // console.log('2020年06月16日17:01:23 onboardingload.vue[描述]——[this.$route.query.filekeyval] :',this.$route.query.filekeyval);
      // if(this.isNotNullOrEmpty(this.record.filekeyval)){
      //   this.record.filerelateid=this.$route.query.filekeyval;
      // }
    },
    /**
     * 提交前校验方法
     */
    beforeSubmit() {

      let flag = true;
      return flag;
    },
    /**
     * 保存前校验方法
     */
    beforeSave() {
      let flag = true;
      return flag;
    },
    /**
    * 校验Deposit Bank、Bank Card Number、Payee Address、Account Type这四个字段任意一个字段有值时，其他字段都为必填
    */
    async checkbankrelated(){
      if( ((this.record.openbank=="" || this.record.openbank==undefined) && (this.record.bankcardnum=="" || this.record.bankcardnum==undefined) && (this.record.payeeaddress=="" || this.record.payeeaddress==undefined) && (this.record.accounttype=="" || this.record.accounttype==undefined)) || ((this.record.openbank)&&(this.record.bankcardnum)&&(this.record.payeeaddress)&&(this.record.accounttype)) ){
        return true;
      }else {
        return false;
      }
    },
    //对上传附件进行校验
    validateFileUpload() {
      this.$refs[this.formName].validateField('mapfileLists');
    },
    //检查时间段是否重复
    // async checktimebucket()
    // {
    //   let result=false;
    //   result=await this.$refs['contractinfoForm'].checktimebucket().then((val)=>{
    //     return val;
    //   });
    //   return result;
    // },
    /**
     * 公用单据加载方法(无流程)
     * blankflag  行项是否默认空行
     */
    doLoadRecordNot4Flow: async function () {
      let oQuery = {};
      let url = "";
      this.record[this.keyname] = this.$route.query[this.keyname];

      if (undefined == this.record[this.keyname] || "" == this.record[this.keyname]) {
        //新增
        this.record.applydeptid = this.$route.query.applydeptid;
        url = this.loadAddAction;
      } else {
        url = this.loadAction;
      }
      oQuery.record = this.record;
      oQuery.editItems = this.editItems;
      oQuery.notNullItems = this.notNullItems;

      // oQuery.linkurlmanageid = this.$route.query.linkurlmanageid;
      // oQuery.nowtimes = this.$route.query.nowtimes;
      // oQuery.applyuserid = this.$route.query.applyuserid;
      oQuery.token = this.$route.query.token;

      if (this.doLoadRecordBefore(oQuery, this.$route.query)) {
        await this.axios.post(url, oQuery).then(({
          data
        }) => {
          if (data.code != "1") {
            //装载失败
            console.log(data.msg);
            return false;
          } else {
            //判断链接是否有效
            if(this.isNotNullOrEmpty(data.data.msg)){
              // this.tipError(data.data.msg);
              this.$router.push({path: '/onboardingerror',name:'onboardingerror',params: {msg: data.data.msg}});
            }else{
              this.currmoduid = data.data.pub_moduid;
              this.btype = data.data.btype;
              this.bill_applyuserkey_name = data.data.bill_applyuserkey_name;
              this.record = data.data.record;
              this.editItems = data.data.edititems; //无流程单据编辑项加载
              this.notNullItems = data.data.notNullItems; //无流程单据必填项加载

              //暂时使用流程编辑域控制
              let tempEditItems='FIELPHTO;ADDRESUME;ADDEDU;ADDFAM;ADDTRAINING;ADDOFF;ADDCOM;';
              this.process.editItems=data.data.edititems+tempEditItems;
              this.process.notnullitems= data.data.notNullItems;

              this.record.delrowids = [];
              //初始化无流程编辑项信息
              //判断行项是否有新增行项的编辑权限
              if (
                this.editItems != undefined &&
                this.editItems != null &&
                this.editItems.indexOf(";ADD;") != -1
              ) {
                this.editItemShow = true;
              }
              this.$formValidate.initViewInfo4NotFlow(
                this,
                data.data.formValidateInfo
              );

              this.doLoadRecordAfter(oQuery, data);
            }
          }
        });
      }
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return (r[2]);
      return null;
    },
    confireSubmit() {
      this.tipCustomConfirm("default", this.$t('onboardingload.ifsubmit'), "").then(() => {
        this.savebill();
      });
    },

    /**
    * 保存业务单据
    */
    async savebill(){
      
      let params = {
          act : "save",
          record: this.record,
          process: this.process,
          inparam: this.$route.query.token
        };
      try {
          if(!(await this.beforesave())){
              return;
          }
      } catch (error) {}
      // await formValidate.bindRules4Flow(this,'submit');
      await formValidate.clearFormValidateTip(this);
      this.formTipArray.length=0; 
      this.$nextTick(() => {
          Promise.all(this.buildForms())
          .then(() => { 
              this.axios.post(this.saveAction, params).then(({ data }) => {
              var code = data.code; 
              console.info(code);
              if (code != "1") {
                  this.returnflag = false;
              } else {
                  this.params = data.data.params;
                  //重新设置record的主键的值
                  this.$router.push({
                  path: this.currRouterPath,
                  query: data.data.params
                  });
                  //动态设置服务端返回来的参数值
                  var returnParams = data.data.params;
                  for (var key in returnParams) {
                  //遍历json对象的每个key/value对,p为key
                  console.info(key + " " + returnParams[key]);
                  this.record[key] = returnParams[key];
                  }

                  this.tipSuccess(this.$t("flow_process.savesuccess"));
                  this.doLoadRecordNot4Flow();

                  // this.axios.post('onboarding/sendMail', params).then(({ data }) => {
                  //   console.log('2020年06月11日16:57:26 onboardingload.vue[描述]——[data] :',data);
                  // });
              }
              });
          })
          .catch(error => {
              console.log("==",error)
              if(this.formTipArray.length > 0){
                  let oFormValidateTip = this.formErrorTip2(
                  this.$t("flow_process.msgtitle"),
                  this.formTipArray
                  );
                  formValidate.pushFormValidateTip(this.$parent, oFormValidateTip);
              }else{
                  this.tipError(this.$t("flow_process.saveerror2")); 
              }
          });
      });
    },
    buildForms() {
      let aForm = [];
      let sMainFormName = this.validFormInfo.mainFormName;
      if (sMainFormName) {
        aForm.push(
          new Promise((resolve, reject) => {
            console.log('2020年06月16日19:11:29 onboardingload.vue[mainFormName]——[this.$refs[sMainFormName]] :',this.$refs[sMainFormName]);
            this.$refs[sMainFormName].validate(valid => {
              if (valid) {
                resolve();
              } else {
                reject();
              }
            });
          })
        );
      }

      let aChildComponentName = this.validFormInfo.childComponentName;
      if (aChildComponentName) {
        for (let currChildComponentName of aChildComponentName) {
          if (!currChildComponentName) {
            continue;
          }
          aForm.push(
            new Promise((resolve, reject) => {
              console.log('2020年06月16日19:14:36 onboardingload.vue[描述]——[currChildComponentName] :',currChildComponentName);
              console.log('2020年06月16日19:11:50 onboardingload.vue[aChildComponentName]——[this.$refs[currChildComponentName]] :',this.$refs[currChildComponentName]);
              this.$refs[currChildComponentName].$refs[
                "ruleForm"
              ].validate(valid => {
                if (valid) {
                  resolve();
                } else {
                  reject();
                }
              });
            })
          );
        }
      }

      return aForm;
    },
  },

  /**
   * 表单dom元素加载完毕
   */
  created() {
    this.init().then(() => {
      this.doLoadRecordNot4Flow();
    });
  },
  computed: {
    ifsave: function () {
      if (this.isNotNullOrEmpty(this.$route.query.id)) {
        return false;
      } else {
        return true;
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/pcpage/hr/onboarding/onboarding/onboardingload.vue